import { MarketLeadershipSection } from 'shared/components/MarketLeadershipSection';
import { HeaderContainer } from '../Header';
import { NewUserBonusBannerContainer } from '../NewUserBonusBanner';
import { BonusStepsSection } from 'shared/components/BonusStepsSection';
import { BonusUsageSection } from 'shared/components/BonusUsageSection';
import { PreFooterNotice } from 'shared/components/PreFooterNotice';
import { FooterContainer } from '../Footer';
import { ModalContainer } from '../ModalContainer';
import { Fragment } from 'react/jsx-runtime';

export const ContentContainer: React.FC = () => {
  return (
    <Fragment>
      <HeaderContainer />
      <NewUserBonusBannerContainer />
      <MarketLeadershipSection />
      <BonusStepsSection />
      <BonusUsageSection />
      <PreFooterNotice />
      <FooterContainer />
      <ModalContainer />
    </Fragment>
  );
};
